export class AppUrl {
  host: string = "https://admapp.jnnet.com.br"; // local - http://172.20.0.65:6058
  host_assine: string = "http://172.20.0.65:6063";
  host_minha_loga: string = "http://localhost:4200/#/";
  host_ms_fatura: string = "https://sgt.loga.net.br/z25f6ab772";
}


// export class AppUrl {
//   host: string = "https://admapp.jnnet.com.br"; // local - http://172.20.0.65:6058
//   host_assine: string = "http://172.20.0.65:6063";
//   host_minha_loga: string = "http://localhost:4200/#/";
//   host_ms_fatura: string = "http://ms-homologacao.loga.net.br/z25f6ab772";
// }



// WEBPACK FOOTER //
// /var/www/minha-jnnet/src/app/app-url.ts